<smart-edit #DayNameEdit [(value)]="Day.name" [readonly]="readonly" [DisplaySecond]="true" [CallbackThis]="this" [(SecondDisplayCallback)]="GetDayLabel" (customfocusout)="onCusomFocusout()" (keyup)="onKeyup($event)"></smart-edit>
